import { render } from "./EditChecklistDialog.vue?vue&type=template&id=645b94ba"
import script from "./EditChecklistDialog.vue?vue&type=script&lang=js"
export * from "./EditChecklistDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__